<template>
  <div class="video-group">
    <video class="video" :src="url" controls autoplay></video>
    <i @click="closeVideo" class="el-icon-circle-close close"></i>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    closeVideo() {
      this.$emit('closeVideo');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.video-group {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  @include flex(row, center);
  justify-content: center;
  .video {
    width: 640px;
    height: 360px;
    background: #000;
  }
  .close {
    &::before {
      font-size: 40px;
      color: #fff;
    }
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
  }
}
</style>